<template>
  <div class="meeting-sign">
    <div class="meeting-header">
      <i @click="back" class="arrow-left el-icon-arrow-left"></i>单位名称
    </div>
    <div class="meeting-body">
      <el-form :model="saveModel" ref="saveForm" class="saveForm">
        <el-form-item
          prop="orgName"
          :rules="{
            required: true,
            message: '单位名称不能为空',
            trigger: 'blur'
          }"
        >
          <el-input
            placeholder="请输入单位名称"
            rows="4"
            type="textarea"
            show-word-limit
            maxlength="50"
            v-model.trim="saveModel.orgName"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="meeting-footer">
      <button @click="save">保存</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrgNamePage",
  data() {
    return {
      hasOfficePhone: "",
      saveModel: {
        orgName: ""
      }
    };
  },
  methods: {
    save() {
      this.$refs.saveForm.validate(valid => {
        if (valid) {
          var model = this.$route.params;
  
          model.orgName = this.saveModel.orgName;
          model.hasOfficePhone = this.hasOfficePhone;
          this.$router.replace({ name: "SubmitPage", params: model });
        }
      });
    },
    back() {
      var model = this.$route.params;
      this.$router.replace({ name: "SubmitPage", params: model });
      this.$route.back();
    }
  },
  created() {
    this.hasOfficePhone = this.$route.params.hasOfficePhone;
    this.saveModel.orgName = this.$route.params.orgName;
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.back, false);
    }
  }
};
</script>
<style>
.meeting-sign {
  background-color: #f9f9f9;
  height: 100vh;
  position: relative;
  overflow: hidden;
}
.meeting-header {
  background-color: #b6242b;
  color: #ffffff;
  width: 100%;
  height: 90px;
  line-height: 90px;
  text-align: center;
}
.meeting-body {
  background-color: #ffffff;
  margin-top: 20px;
}
.meeting-body .submitForm .el-form-item {
  border-bottom: 1px solid #dddee1;
  margin-left: 20px;
}
.meeting-body .submitForm .el-input__inner {
  border: none;
}
.meeting-footer {
  position: fixed;
  bottom: 20px;
  left: 30px;
  width: calc(100% - 60px);
}
.meeting-footer button {
  width: 100%;
  padding: 20px 0;
  background-color: #b6242b;
  color: #ffffff;
  border: 1px solid #b6242b;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/orgNamePage.vue